export const setLangPage = (isRtl, langCode) => {
  document.documentElement.lang = langCode;

  if (isRtl) {
    document.documentElement.dir = 'rtl';
  } else {
    document.documentElement.dir = 'ltr';
  }
};
